import { NgModule } from '@angular/core';
import { AuthenticatedLayoutComponent } from './pages/authenticated-layout.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@core/material/material.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AuthenticatedLayoutComponent],
  imports: [CommonModule, MaterialModule, RouterModule],
  exports: [AuthenticatedLayoutComponent, RouterModule],
})
export class AuthenticatedLayoutModule {}
